module.exports = __webpack_public_path__ + "img/Sweden.1cf04c85.svg";